import { render, staticRenderFns } from "./PainelAmostra.vue?vue&type=template&id=4dc84378&"
import script from "./PainelAmostra.vue?vue&type=script&lang=js&"
export * from "./PainelAmostra.vue?vue&type=script&lang=js&"
import style0 from "./PainelAmostra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
